export default __webpack_public_path__ + "static/Sketches-92535f8850e1f37e4b03ae72348d4ea9.png";